import React, {createContext} from 'react';

export const CallToActionContext = createContext();

class CallToActionContextProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            showTaxiBookingDialogue:false,
            showPassBookingDialogue:false
        };
    }   

    render() {
        return (
            <CallToActionContext.Provider value={{
                ...this.state,
                setState:this.setState.bind(this)
            }}>
                {this.props.children}
            </CallToActionContext.Provider>
        );
    }
}

export default CallToActionContextProvider;